module.exports = __webpack_public_path__ + "static/img/hxjs_banner.c300fb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/hxjs_banner.png
// module id = tAlb
// module chunks = 1